import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { Page, PageHeader } from '../ui'
import { ReportLinksView } from '../components/views/reportLinksView'

function ReportLinks() {
    return (
        <div className="reportLinks">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader eyebrow="Sentinel Tools" title="Report Builder" intro="Build custom reports or download the pre-configured ones for legal ops." />
                    <ReportLinksView />
                </Page>
            </MainView>
        </div>
    )
}

export default ReportLinks
